export enum BlockGroup {
    INPUTS = "Inputs",
    SECTIONS = "Sections",
    MODULES = "Modules",
}

export enum BlockSource {
    BASIC = "basic",
    CUSTOM = "custom",
}

export type BlockItem = {
    id: string;
    label: string;
    description?: string;
    group: BlockGroup;
    source: BlockSource;
    content: string | (() => string);
    templateId?: string;
};
